export const config = {
    apiUrl: 'https://integration.ziplineplatform.com/',
    // apiUrl: 'https://zipline-api-test.herokuapp.com/',
    // apiUrl: 'https://212f-117-222-164-238.in.ngrok.io/',
    // apiUrl_exerp: 'http://165.22.215.180/',
    apiUrl_exerp: 'https://zipleads-api.abacies.com/'
}